(function () {
    'use strict';

    // Ghost's own front-end script (loaded via {{ghost_foot}}) handles the
    // actual submission of any [data-members-form] and adds a "success" or
    // "error" class to it once done. This only adds a loading state in the
    // gap between submit and that class landing, and an optional
    // copy-link affordance elsewhere on the page - both allowed under
    // Azimuth's JS scope (Azimuth.md, Technische opzet).
    var forms = document.querySelectorAll('[data-members-form]');

    Array.prototype.forEach.call(forms, function (form) {
        form.addEventListener('submit', function () {
            form.classList.add('is-loading');
        });

        var observer = new MutationObserver(function () {
            if (form.classList.contains('success') || form.classList.contains('error')) {
                form.classList.remove('is-loading');
            }
        });
        observer.observe(form, {attributes: true, attributeFilter: ['class']});
    });

    var copyButtons = document.querySelectorAll('[data-az-copy-link]');
    Array.prototype.forEach.call(copyButtons, function (button) {
        button.addEventListener('click', function () {
            var url = button.getAttribute('data-az-copy-link') || window.location.href;
            var label = button.querySelector('[data-az-copy-label]');
            var originalText = label ? label.textContent : null;

            var done = function () {
                if (label) {
                    label.textContent = button.getAttribute('data-az-copy-done') || label.textContent;
                    window.setTimeout(function () {
                        if (originalText !== null) {
                            label.textContent = originalText;
                        }
                    }, 2000);
                }
            };

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(done, function () {});
            }
        });
    });
}());
